<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>{{msg}}</h1>
        <!-- <span class="pull-right icon-right" v-tap="isHideEdit = false" v-if="rollcallTeacherId == teacherId || cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2">编辑</span> -->
        <router-link class="pull-right icon-right orange" :to="{path: '/remind/list'}" tag="span">提醒</router-link>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page " v-bind:class="{'roll-edit': callState == 2, 'roll-get': callState == 1}" style="padding-bottom:60px;">
      <div class="bg-white padding-15 font-12" style="margin-top:10px;">
        <span class="block font-16">温馨提示:</span>
        <p class="gray" style="margin-top:5px">点击右上角 “<span class="orange">提醒</span>” 可以设置定时推送消息，到设定时间后，系统会自动推送一条消息给家长，提醒家长及时接回孩子！</p>
      </div>
      <template v-if="callState == 1">
      <div v-for="item in rollcallList" v-if="item.studentList.length > 0">
        <span class="margin-15 block">{{item.grade}}</span>
        <ul class="list-group-item bigger" >
          <li class="list-group" v-for="student in item.studentList" @click="updateRollcallState($event, student)">
            <div class="liner"></div>
            <div class="group-link clearfix">
              <div class="img-wrap pull-left big">
                <img class="pull-left" :src="student.imageAddress ? item.baseAcessPath + student.imageAddress : img_default" width="100%"/>
              </div>
              <span class="group-txt" style="padding-top:0">
                <span class="block overhide">
                  <cite class="font-16 pull-left">{{student.studentName}}</cite>
                  <i class="img-sex" v-bind:class="{'boy': student.sex == '男','girl': student.sex == '女'}">{{student.sex}}</i>
                </span>
                <span class="block gray" v-if="student.callState == 1">{{student.callTime}}</span>
                <span class="gray" v-if="!student.parentRole">待家长确认</span>
                <span class="green" v-if="student.parentRole">家长已确认</span>
              </span>
              <span class="no-get" v-if="!student.parentRole && !isBefore"><a @click.prevent.stop="isHideRollcallNo = false, setStudentDialog(student, item.baseAcessPath, item.grade)">未接回</a></span>
            </div>
          </li>
        </ul>
      </div>
      </template>

      <template v-if="callState == 2">
      <div v-for="item in rollcallList" v-if="item.studentList.length > 0">
        <span class="margin-15 block">{{item.grade}}</span>
        <ul class="list-group-item bigger">
          <li class="list-group" v-for="student in item.studentList">
            <div class="liner"></div>
            <div class="group-link clearfix">
              <div class="img-wrap big pull-left">
                <img :src="student.imageAddress ? item.baseAcessPath + student.imageAddress : img_default" width="100%"/>
              </div>
              <span class="group-txt">
                <span class="block overhide">
                  <cite class="font-16 pull-left">{{student.studentName}}</cite>
                  <i class="img-sex" v-bind:class="{'boy': student.sex == '男','girl': student.sex == '女'}">{{student.sex}}</i>
                </span>
                <cite class="gray">{{item.grade}}{{student.className}}{{student.typeName ? '（' + student.typeName +'）' : ''}}</cite>
              </span>
              <span class="pull-right" v-if="student.callState == 2"><a class="button-roll" @click.prevent.stop="isHideRollcallOk = false, setStudentDialog(student, item.baseAcessPath, item.grade)">接回</a></span>
            </div>
          </li>
        </ul>
      </div>
      </template>

    </div>
    <div class="bottom-bar">
      <div class="tabs">
        <div class="liner"></div>
        <ul class="clearfix text-center font-14">
          <li class="col-xs-6" @click="callState = 2, getCallList()" v-bind:class="{'active': callState == 2}"><span>未接回（{{wdd}}）</span></li>
          <li class="col-xs-6" @click="callState = 1, getCallList()" v-bind:class="{'active': callState == 1}"><span>已接回（{{ydd}}）</span></li>
        </ul>

      </div>
    </div>

    <!-- 修改为已签到 -->
    <div class="maskdiv" v-show="!isHideRollcallOk" @click="isHideRollcallOk = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap pop-parents">
          <div class="clearfix margin-x-15">
            <div class="pull-left"><img class="rounded-60" :src="studentDialog.imageAddress ? studentDialog.baseAcessPath + studentDialog.imageAddress : img_default" width="60" height="60"></div>
            <div class="pull-left padding-10 margin-x-15">
              <p class="font-16 clearfix"><span class="pull-left">{{studentDialog.studentName}}</span>
                <span class="pull-left img-sex" v-bind:class="{'boy': studentDialog.sex == '男','girl': studentDialog.sex == '女'}"></span>
              </p>
              <p class="gray">{{studentDialog.grade}}{{studentDialog.className}}{{studentDialog.typeName ? '（' + studentDialog.typeName +'）' : ''}}</p>
            </div>
          </div>
          <p class="text-center padding-15">确定要更改为“ 已接回 ”吗？</p>
          <div class="liner margin-x-15"></div>
          <div class="clearfix text-center">
            <div class="col-xs-6">

              <a @click.prevent="updStatus(1)" class="blue block padding-15" v-if="upd_status_para.isLoading == false">
                <span class="block" style="border-right:1px solid #e3e3e3">确定</span>
              </a>
              <a class="blue block padding-15" v-else>
                <span class="block" style="border-right:1px solid #e3e3e3">确定</span>
              </a>

            </div>
            <div class="col-xs-6"><a @click.prevent="isHideRollcallOk = true" class="blue block padding-15"><span class="block">取消</span></a></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改为未签到 -->
    <div class="maskdiv" v-show="!isHideRollcallNo" @click="isHideRollcallNo = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap pop-parents">
          <div class="clearfix margin-x-15">
            <div class="pull-left"><img class="rounded-60" :src="studentDialog.imageAddress ? studentDialog.baseAcessPath + studentDialog.imageAddress : img_default" width="60" height="60"></div>
            <div class="pull-left padding-10 margin-x-15">
              <p class="font-16 clearfix"><span class="pull-left">{{studentDialog.studentName}}</span>
                <span class="pull-left img-sex" v-bind:class="{'boy': studentDialog.sex == '男','girl': studentDialog.sex == '女'}"></span>
              </p>
              <p class="gray">{{studentDialog.grade}}{{studentDialog.className}}{{studentDialog.typeName ? '（' + studentDialog.typeName +'）' : ''}}</p>
            </div>
          </div>
          <p class="text-center padding-15">确定要更改为“ 未接回 ”吗？</p>
          <div class="liner margin-x-15"></div>
          <div class="clearfix text-center">
            <div class="col-xs-6">

              <a @click.prevent="updStatus(2)" class="blue block padding-15" v-if="upd_status_para.isLoading == false">
                <span class="block" style="border-right:1px solid #e3e3e3">确定</span>
              </a>
              <a href="javascript:;" class="blue block padding-15" v-else>
                <span class="block" style="border-right:1px solid #e3e3e3">确定</span>
              </a>

            </div>
            <div class="col-xs-6"><a @click.prevent="isHideRollcallNo = true" class="blue block padding-15"><span class="block">取消</span></a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_call_student_list_by_grade_para: service.setPara('getCallStudentListByGrade'),
      update_roll_status_para: service.setPara('updRollStatus'), // 更新点名状态
      upd_status_para: service.setPara('updStatus'), // 更新单条状态
      rollcallId: 0,
      curcheId: 0,
      callState: 2,
      rollcallList: [],
      wdd: 0, // 未定到数量
      ydd: 0, // 已定到数量
      state: 0, // 点名状态
      msg: '', // 点名标题
      teacherId: 0,
      rollcallTeacherId: 0,
      isHideEdit: true,
      isHideRollcallOk: true, // 签到弹出框
      isHideRollcallNo: true, // 未签到弹出框
      isFirstLoad: true, // 是否定一次加载
      // 修改签到状态弹出框
      studentDialog: {},
      timer: 0,
      isBefore: false
    }
  },
  mounted: function () {
    this.rollcallId = this.$route.params.rollcallId
    // 极光推送
    if (window.device) {
      document.addEventListener('jpush.receiveMessage', this.receiveMessage, false)
    }
    // $('div.maskdiv,div.maskdiv div.slider').css('height', $(window).height())
    this.getCallList()
  },
  methods: {
    getCallList: function () {
      this.curcheId = this.cookie_login_data.curcheId
      this.teacherId = this.cookie_login_data.teacherId
      this.get_call_student_list_by_grade_para.curcheId = this.curcheId
      this.get_call_student_list_by_grade_para.callId = this.rollcallId
      this.get_call_student_list_by_grade_para.callState = this.callState

      let that = this
      let obj = {context: this, para: this.get_call_student_list_by_grade_para, isIndicator: false, successFun: (response) => {
        that.wdd = response.data.wdd
        if (that.isFirstLoad && that.wdd == 0) {
          that.isFirstLoad = false
          that.callState = 1
          that.getCallList()
          return
        }
        that.rollcallList = response.data.list
        that.ydd = response.data.ydd
        that.msg = response.data.msg
        that.state = response.data.state
        that.rollcallTeacherId = response.data.teacherId
        let createTime = new Date(response.data.createTime)
        if (createTime.getDate() != new Date().getDate()) {
          that.isBefore = true
        }
      }}
      service.request(obj)
    },
    updRollStatus: function (state) { // 修改点名状态
      this.update_roll_status_para.teacherId = this.teacherId
      this.update_roll_status_para.callId = this.rollcallId
      this.update_roll_status_para.state = state

      let obj = {context: this, para: this.update_roll_status_para, successFun: (response) => {
        Toast('操作成功')
        window.history.go(-1)
      }}
      service.request(obj)
    },
    updStatus: function (state) { // 修改学生的签到状态
      this.isHideRollcallOk = true
      this.isHideRollcallNo = true
      this.upd_status_para.studentId = this.studentDialog.studentId
      this.upd_status_para.teacherId = this.teacherId
      this.upd_status_para.callId = this.rollcallId
      this.upd_status_para.callState = state

      let obj = {context: this, para: this.upd_status_para, successFun: (response) => {
        this.removeStudentFromCall(this.studentDialog.studentId)
      }, not100CodeFun: (response) => {
        if (response.code == '109') {
          this.removeStudentFromCall(this.studentDialog.studentId)
        } else {
          Toast(response.msg)
        }
      }}
      service.request(obj)
    },
    setStudentDialog: function (student, baseAcessPath, grade) {
      this.studentDialog = student
      this.studentDialog.baseAcessPath = baseAcessPath
      this.studentDialog.grade = grade
      if (this.isBefore) {
        this.isHideRollcallOk = true
        Toast('亲，家长接回点名只能当日点哦！')
      }
    },
    updateRollcallState: function (obj, student) {
      if (student.parentRole) {
        return
      }
      if (this.callState == 1 && (this.state == 2 || this.state == 3)) {
        $('.list-group .group-link').not($(obj.target).parents('.group-link')).css('margin-left', '0')
        var cssValue = $(obj.target).parents('.group-link').css('margin-left')
        if (cssValue == '-80px') {
          $(obj.target).parents('.group-link').animate({'margin-left': '0'}, 150)
        } else {
          $(obj.target).parents('.group-link').animate({'margin-left': '-80px'}, 150)
        }
      }
    },
    receiveMessage: function (event) {
      try {
        var message = ''
        var extras = {}
        if (window.device.platform == 'Android') {
          message = event.message
          extras = event.extras
        } else {
          message = event.content
          extras = event.extras
        }
        console.log(message)
        if (extras.callId == this.rollcallId) {
          if (extras.callState != this.callState) {
            this.removeStudentFromCall(extras.studentId)
          } else {
            this.getCallList()
          }
        }
      } catch (exception) {
        console.log('JPushPlugin:onReceiveMessage-->' + exception)
      }
    },
    removeStudentFromCall: function (studentId) {
      for (var i = 0; i < this.rollcallList.length; i++) {
        var grade = this.rollcallList[i]
        var flag = false
        for (var j = 0; j < grade.studentList.length; j++) {
          if (grade.studentList[j].studentId == studentId) {
            grade.studentList.splice(j, 1)
            flag = true
            if (this.callState == 2) {
              this.wdd--
              this.ydd++
            } else {
              this.ydd--
              this.wdd++
            }
            break
          }
        }
        if (flag) break
      }
      $('.list-group .group-link').css('margin-left', '0')
    }
  },
  beforeDestroy: function () {
    // window.clearTimeout(this.timer)
    if (window.device) {
      document.removeEventListener('jpush.receiveMessage', this.receiveMessage, false)
    }
  }

}
</script>
<style scoped>
  .main-page{padding-bottom:45px;}
</style>



// WEBPACK FOOTER //
// rollcallHand.vue?4e6147de